import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SkyLogService } from './log.service';


export class SkyLogModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule],
  providers: [
    SkyLogService
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
